<template>
  <div v-if="relance && getFacturesCodes">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('addNewRelance.title', {
                code: getFacturesCodes,
                }) }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button is-cancel btn-modal-annuler "
                    @click="$router.go(-1)">
            {{ $t('addNewRelance.actions.cancel')}}
          </button>
            <button class="button is-addOrEdit " @click="saveRelance()">
              {{ $t('general.button.sauvegarder')}}
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="permRelance.maj">
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </div>
    <br>
    <error-msg-component
      v-if="error"
      :messages="messages"
      :messagesChampsVide="messagesChampsVide"
      :champsVide="champsVide"
      :error="error"
      :title="'general.problemOccurred'"
      :withEmplyFields="true"
      @close="error = $event"/>
    <div class="columns">
      <div class="column is-9">
        <div class="card">
          <div class="card-content">
            <app-header-relance
              :date.sync="relance.dateRelance"
              :numberRelance.sync="relance.numRelance"
              @reinitialiserTexte="updateTexteRelance"/>
            <p class="has-text-weight-bold has-text-default mgb-8px">
              {{ $t('addNewRelance.messageRelance')}}
            </p>
            <qd-text-editor
              v-model="relance.texte"
              :key="relance.numRelance"
              :height="500" />
          </div>
        </div>
        <div class="card mgt-20px">
          <header class="header-card">
            <p>{{ $t('relance.commentaire')}}</p>
          </header>
          <div class="card-content">
            <b-field
              :label="$t('addNewRelance.commentaire')">
              <b-input v-model="relance.commentaire" type="textarea" :rows="4">
              </b-input>
            </b-field>
          </div>
        </div>
        <br>
        <div class="card">
          <header class="header-card">
            <p>{{ $t('piecesJointes.attachments')}}</p>
          </header>
          <div class="card-content">
            <app-pieces-jointes :checkPermissions="true"/>
          </div>
        </div>
      </div>
      <div class="column is-3" v-if="allRelances">
        <step-relance-enregistrement
          :allRelances="allRelances"
          :idCurrentRelance="relance.id">
        </step-relance-enregistrement>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AppBreadcrumb from '@/components/general/breadcrumb';
import PiecesJointes from '@/components/general/piecesJointes';
import messageErreur from '@/services/general/messageErreur';
import AppHeaderRelance from '@/components/relances/headerRelance';
import { get, update, getTexte } from '@/api/relances/index';
import messageSucces from '@/services/general/messageSucces';
import stepRelanceEnregistrement from '@/components/relances/stepRelanceEnregistrement';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { RELANCE } from '@/configuration/permissionsBodacConf';
import preparationEnvoiBack from '@/services/relances/preparationEnvoieBack';
import validation from '@/services/relances/validation';
import translate from '@/services/relances/champsRelanceTranslator';
import validationGeneral from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import formatIsoDate from '@/services/general/formatIsoDate';

const Attachments = createNamespacedHelpers('attachments');

export default {
  data() {
    return {
      relance: null,
      allRelances: null,
      permRelance: RELANCE,
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
    };
  },
  components: {
    AppBreadcrumb,
    appPiecesJointes: PiecesJointes,
    AppHeaderRelance,
    stepRelanceEnregistrement,
    pieceJointeButton,
    errorMsgComponent,
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      updateAttachments: 'update',
      setAttachmentElementId: 'setElementId',
    }),
    async saveRelance() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const newRelance = preparationEnvoiBack(this.relance, false);
        await update(newRelance);
        await this.updateAttachments(this.$route.params.id);
        messageSucces(this.$t('addNewRelance.editSuccess'));
        this.$router.push({
          name: 'c.bodac.relance',
          params: {
            relanceId: this.relance.id,
          },
        });
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          this.messages = [];
          this.messagesChampsVide = [];
          this.champsVide = [];
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validation(e.response, this.messages);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async updateTexteRelance() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = {
          mouvementClientIds: this.relance.mouvementsClients.map(el => el.mouvementClientId),
          referenceTexte: this.relance.numRelance > 3 ? 3 : this.relance.numRelance,
          dateRelance: formatIsoDate(this.relance.dateRelance),
        };
        this.relance.texte = (await getTexte(params)).data.result;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('listeFactures.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('relance.titleRelances'), route: { name: 'l.bodac.relance-listeRelancesSave' }, isActive: false },
        { title: this.$t('addNewRelance.relance'), route: '', isActive: true },
      ];
    },
    getFacturesCodes() {
      return [...new Set(this.relance.mouvementsClients.map(mvt => {
        return mvt.facture.code;
      }))].join(', ');
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Relance' });
      await this.setAttachmentElementId({ id: this.$route.params.id });
      this.relance = (await get(this.$route.params.id)).data.result;
      this.relance.payeur.id = this.relance.payeurId;
      this.relance.dateRelance = new Date(this.relance.dateRelance);
      this.allRelances = [this.relance];
      this.setInformationPage(this.$t('pageGeneral.modification', { item: this.getFacturesCodes }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
